import React, { FC } from 'react'

import { Icon } from 'src/components/atoms'

type Props = {
  submitButtonType?: 'submit' | 'button'
  disabledCancel?: boolean
  disabledSubmit?: boolean
  disabledDelete?: boolean
  onClickDelete: () => void
  onClickCancel: () => void
  onClickSubmit?: () => void
  className?: string
}

export const EditModeIconsSet: FC<Props> = ({
  submitButtonType = 'submit',
  onClickDelete,
  onClickCancel,
  onClickSubmit,
  disabledCancel = false,
  disabledSubmit = false,
  disabledDelete = false,
  className,
}) => {
  return (
    <div className={className}>
      <div className="tw-inline-flex tw-gap-r2">
        <button type="button" onClick={onClickDelete} disabled={disabledDelete}>
          <Icon
            size="--r2"
            path="trash/soft/line"
            className={
              disabledDelete
                ? 'tw-text-standardText-disable'
                : 'tw-text-standardText-secondary hover:tw-text-standardText-primary'
            }
          />
        </button>
        <button type="button" onClick={onClickCancel} disabled={disabledCancel}>
          <Icon
            size="--r2"
            path="close/soft/line"
            className={
              disabledCancel
                ? 'tw-text-standardText-disable'
                : 'tw-text-standardText-secondary hover:tw-text-standardText-primary'
            }
          />
        </button>
        {/* eslint-disable-next-line react/button-has-type */}
        <button type={submitButtonType} onClick={onClickSubmit} disabled={disabledSubmit}>
          <Icon
            size="--r2"
            path="check/soft/line"
            className={
              disabledSubmit
                ? 'tw-text-standardText-disable'
                : 'tw-text-standardText-secondary hover:tw-text-standardText-primary'
            }
          />
        </button>
      </div>
    </div>
  )
}
